//Description : show more and show less text - Reusable

import { Tooltip, styled } from '@mui/material';
import React, {useState} from 'react';

export const ShowMoreText = ({value, style, max}) => {

  const [isTrue, setIsTrue] = useState(false);
  
  if(value && value.length > max){
    return (
        <>
            {isTrue ? `${value} ` : `${value.substring(0, max)}... `}
            <button style={style} onClick={() => setIsTrue(!isTrue)}>{isTrue ? " read less" : " read more"}</button>
        </>
    )
  }else{
    return(
      value
    )
  }
}

const StyledTooltip = ({ className, ...props }) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
);
export const ShowFullText = styled(StyledTooltip)(({theme}) => ({
  backgroundColor: 'white',
  color: 'black',
  maxWidth: 500,
  fontSize: "15px",
  boxShadow: theme.shadows[5]
}));